import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { defineMessages } from 'react-intl';
import Button from '@alltrails/shared/denali/components/Button';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { LanguageSupportUtil } from 'utils/language_support_util';
import ReferralLayout from 'components/ReferralLayout';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import { logInvitedUserCreateAccountClicked, logInvitedUserLandingPageViewed } from '@alltrails/analytics/amplitudeFunctions';
import useFormatMessage from 'hooks/useFormatMessage';
import landingPage1Avif from './landing-page-1-1400w.avif';
import landingPage1Webp from './landing-page-1-1400w.webp';
import landingPage1Jpg from './landing-page-1-1400w.jpg';
import * as styles from './styles.module.scss';
import heartSrc from './heart.svg';

const messages = defineMessages({
  createFreeAccount: {
    defaultMessage: 'Create a free account'
  }
});

const { INVITED_YOU, A_CLOSE_UP_OF_TWO, HEART_ICON, HEADS_UP_THIS_OFFER_IS_FOR_NEW_MEMBERS_ONLY, ONCE_YOU_SIGN_UP, TERMS_AND_CONDITIONS } =
  StringConstantsMixin.strings;

function ReferralWelcome({ firstName }) {
  const languageRegionCode = useLanguageRegionCode();
  const {
    formattedDefaultMessages: { createFreeAccount }
  } = useFormatMessage(messages);

  const { referralLink } = useParams();

  useEffect(() => {
    logInvitedUserLandingPageViewed();
  }, []);

  return (
    <>
      <ReferralLayout
        activeStep={0}
        heroAvif={landingPage1Avif}
        heroWebp={landingPage1Webp}
        heroJpg={landingPage1Jpg}
        heroAlt={A_CLOSE_UP_OF_TWO}
        heading={INVITED_YOU.replace('{firstName}', firstName)}
        iconSrc={heartSrc}
        iconAlt={HEART_ICON}
        paragraphText={ONCE_YOU_SIGN_UP}
      >
        <Link to={`${referralLink}/signup`} onClick={logInvitedUserCreateAccountClicked}>
          <Button text={createFreeAccount} className={styles.button} testId="referral-create-free-account" variant="primary" />
        </Link>
        <p className={styles.disclaimer}>{HEADS_UP_THIS_OFFER_IS_FOR_NEW_MEMBERS_ONLY}</p>
      </ReferralLayout>
      <footer className={styles.terms}>
        <p>
          <a href={LanguageSupportUtil.wrapUrlSafe('/terms', languageRegionCode)}>{TERMS_AND_CONDITIONS}</a>
        </p>
      </footer>
    </>
  );
}

export default ReferralWelcome;
